import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzRecipeImagesSquare from '~/components/_next/molecules/AzRecipeImagesSquare.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarAddRecipeToWishlistOrganism',
  setup: function setup(__props) {
    var _useRecipesWishlists = useRecipesWishlists(),
      loadRecipesWishlists = _useRecipesWishlists.loadRecipesWishlists,
      addRecipeToWishlist = _useRecipesWishlists.addRecipeToWishlist,
      recipesWishlists = _useRecipesWishlists.recipesWishlists,
      canAddNewList = _useRecipesWishlists.canAddNewList;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar,
      toggleCreateRecipeWishlistSidebar = _useUiState.toggleCreateRecipeWishlistSidebar,
      recipeToAdd = _useUiState.recipeToAdd;
    var hasRecipesWishlist = computed(function () {
      return recipesWishlists.value.length !== 0;
    });

    /**
     * Gets the wishlist images.
     *
     * @param      {RecipeWishlist}  wishlist  The wishlist
     * @return     {string[]}        The wishlist images.
     */
    function getWishlistImages(wishlist) {
      return wishlist.items.slice(0, 3).map(function (item) {
        return item.image;
      });
    }

    /**
     * Adds a recipe to the given wishlist.
     *
     * @param      {string}   wishlistId  The wishlist identifier
     */
    function addRecipe(_x) {
      return _addRecipe.apply(this, arguments);
    }
    /**
     * Toogle the create recipe wishlist sidebar
     * and then toggles back this sidebar to add the recipe.
     */
    function _addRecipe() {
      _addRecipe = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(wishlistId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return addRecipeToWishlist(wishlistId, recipeToAdd.value);
            case 2:
              toggleAddRecipeToWishlistSidebar();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _addRecipe.apply(this, arguments);
    }
    function createWishlistAndAddRecipe() {
      // Need to make a full copy of the object and not just a ref
      // as it can be changed to null whilst interacting with other sidebars
      var recipeToOpen = JSON.parse(JSON.stringify(recipeToAdd === null || recipeToAdd === void 0 ? void 0 : recipeToAdd.value));
      toggleAddRecipeToWishlistSidebar();
      toggleCreateRecipeWishlistSidebar(function () {
        toggleAddRecipeToWishlistSidebar(recipeToOpen);
      });
    }
    onMounted(function () {
      loadRecipesWishlists(true);
    });
    return {
      __sfc: true,
      loadRecipesWishlists: loadRecipesWishlists,
      addRecipeToWishlist: addRecipeToWishlist,
      recipesWishlists: recipesWishlists,
      canAddNewList: canAddNewList,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      toggleCreateRecipeWishlistSidebar: toggleCreateRecipeWishlistSidebar,
      recipeToAdd: recipeToAdd,
      hasRecipesWishlist: hasRecipesWishlist,
      getWishlistImages: getWishlistImages,
      addRecipe: addRecipe,
      createWishlistAndAddRecipe: createWishlistAndAddRecipe,
      AzButton: AzButton,
      AzSidebar: AzSidebar,
      AzImg: AzImg,
      AzIcon: AzIcon,
      AzRecipeImagesSquare: AzRecipeImagesSquare
    };
  }
});